function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", {
  id: "img-intro--kontakt_svg__support-intro-title"
}, "Icon: Sprechblase mit Fragezeichen");

var _ref2 = /*#__PURE__*/React.createElement("desc", {
  id: "img-intro--kontakt_svg__support-intro-desc"
}, "Icon: Sprechblase mit Fragezeichen zum Support der Apotique");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.213 21.97H4.678c-.416-.902-.866-2.03-1.351-3.384a88.23 88.23 0 01-1.404-4.269A63.288 63.288 0 01.728 9.736 37.865 37.865 0 010 5.31c2.634-1.596 5.631-2.88 8.993-3.852C12.354.486 16.633 0 21.832 0 24.95 0 27.74.434 30.2 1.302c2.46.867 4.575 2.047 6.342 3.54a14.971 14.971 0 014.055 5.362C41.532 12.287 42 14.543 42 16.972c0 3.124-.59 5.797-1.767 8.018a23.822 23.822 0 01-4.367 5.883A43.733 43.733 0 0130.2 35.56a53.338 53.338 0 00-5.717 4.581 23.718 23.718 0 00-4.419 5.467c-1.178 2.013-1.767 4.477-1.767 7.393h-3.43c-.971-3.193-1.335-5.953-1.092-8.278.242-2.325.814-4.425 1.715-6.3a23.09 23.09 0 013.327-5.102 97.373 97.373 0 003.794-4.685 29.56 29.56 0 003.12-5.103c.866-1.804 1.299-3.887 1.299-6.247 0-1.32-.156-2.62-.468-3.905-.312-1.284-.832-2.412-1.56-3.384-.727-.972-1.663-1.753-2.806-2.343-1.144-.59-2.547-.885-4.21-.885-1.456 0-2.738.139-3.847.417-1.11.277-1.941.624-2.495 1.04L8.213 21.972zM8 66.554c0-2.566.857-4.633 2.57-6.2C12.285 58.783 14.558 58 17.389 58c2.832 0 5.141.784 6.93 2.352C26.106 61.92 27 63.987 27 66.553c0 2.567-.894 4.616-2.682 6.148C22.529 74.234 20.22 75 17.388 75c-2.831 0-5.104-.766-6.817-2.299C8.857 71.17 8 69.12 8 66.553z",
  id: "img-intro--kontakt_svg__path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "img-intro--kontakt_svg__img-intro--kontakt",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M86.777 40.58c49.5 16.608 3.201 55-36.799 67.5s-62.651-64.81-46.97-88.608c15.68-23.797 34.27 4.5 83.77 21.108z",
  id: "img-intro--kontakt_svg__Background-Shape",
  fillOpacity: 0.197,
  fill: "#A12347"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.974 89.681c-7.76 51.632-53.609 12.703-72.865-24.519C-4.147 27.94 68.056-7.792 94.215 3.52c26.158 11.31 1.519 34.53-6.241 86.162z",
  id: "img-intro--kontakt_svg__Background-Shape",
  stroke: "#A12347",
  strokeWidth: 2,
  strokeDasharray: 4
}), /*#__PURE__*/React.createElement("g", {
  id: "img-intro--kontakt_svg__Group",
  transform: "translate(9.777 23.08)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0h59c5.523 0 10 4.477 10 10v34c0 5.523-4.477 10-10 10H48.451L28 67.076V54H10C4.477 54 0 49.523 0 44V10C0 4.477 4.477 0 10 0z",
  id: "img-intro--kontakt_svg__Rectangle",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("circle", {
  id: "img-intro--kontakt_svg__Oval",
  fill: "#A12347",
  cx: 13,
  cy: 28,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  id: "img-intro--kontakt_svg__Oval-Copy",
  fill: "#A12347",
  cx: 29,
  cy: 28,
  r: 6
}), /*#__PURE__*/React.createElement("circle", {
  id: "img-intro--kontakt_svg__Oval-Copy-2",
  fill: "#A12347",
  cx: 45,
  cy: 28,
  r: 6
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 0h59c5.523 0 10 4.477 10 10v34c0 5.523-4.477 10-10 10H48.451h0L28 67.076V54H10C4.477 54 0 49.523 0 44V10C0 4.477 4.477 0 10 0z",
  id: "img-intro--kontakt_svg__Rectangle",
  stroke: "#151616",
  strokeWidth: 1.638,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "img-intro--kontakt_svg__Group-2",
  transform: "translate(65.777 34.08)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.213 21.97H4.678c-.416-.902-.866-2.03-1.351-3.384a88.23 88.23 0 01-1.404-4.269A63.288 63.288 0 01.728 9.736 37.865 37.865 0 010 5.31c2.634-1.596 5.631-2.88 8.993-3.852C12.354.486 16.633 0 21.832 0 24.95 0 27.74.434 30.2 1.302c2.46.867 4.575 2.047 6.342 3.54a14.971 14.971 0 014.055 5.362C41.532 12.287 42 14.543 42 16.972c0 3.124-.59 5.797-1.767 8.018a23.822 23.822 0 01-4.367 5.883A43.733 43.733 0 0130.2 35.56a53.338 53.338 0 00-5.717 4.581 23.718 23.718 0 00-4.419 5.467c-1.178 2.013-1.767 4.477-1.767 7.393h-3.43c-.971-3.193-1.335-5.953-1.092-8.278.242-2.325.814-4.425 1.715-6.3a23.09 23.09 0 013.327-5.102 97.373 97.373 0 003.794-4.685 29.56 29.56 0 003.12-5.103c.866-1.804 1.299-3.887 1.299-6.247 0-1.32-.156-2.62-.468-3.905-.312-1.284-.832-2.412-1.56-3.384-.727-.972-1.663-1.753-2.806-2.343-1.144-.59-2.547-.885-4.21-.885-1.456 0-2.738.139-3.847.417-1.11.277-1.941.624-2.495 1.04L8.213 21.972zM8 66.553c0-2.566.857-4.633 2.57-6.2C12.285 58.783 14.558 58 17.389 58c2.832 0 5.141.784 6.93 2.352C26.106 61.92 27 63.987 27 66.553c0 2.567-.894 4.616-2.682 6.148C22.529 74.234 20.22 75 17.388 75c-2.831 0-5.104-.766-6.817-2.299C8.857 71.17 8 69.12 8 66.553z",
  id: "img-intro--kontakt_svg__Path",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("g", {
  id: "img-intro--kontakt_svg__?-2"
}, /*#__PURE__*/React.createElement("mask", {
  id: "img-intro--kontakt_svg__mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#img-intro--kontakt_svg__path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "img-intro--kontakt_svg__?",
  fill: "#FFF",
  xlinkHref: "#img-intro--kontakt_svg__path-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0-7h18C31-2.918 37.5 5.082 37.5 17c0 16.65-16.03 19.049-19.5 32.813C16.452 55.954 16.452 64.35 18 75H0V-7z",
  id: "img-intro--kontakt_svg__Rectangle",
  fill: "#A12347",
  mask: "url(#img-intro--kontakt_svg__mask-2)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.213 21.97H4.678c-.416-.902-.866-2.03-1.351-3.384a88.23 88.23 0 01-1.404-4.269A63.288 63.288 0 01.728 9.736 37.865 37.865 0 010 5.31c2.634-1.596 5.631-2.88 8.993-3.852C12.354.486 16.633 0 21.832 0 24.95 0 27.74.434 30.2 1.302c2.46.867 4.575 2.047 6.342 3.54a14.971 14.971 0 014.055 5.362C41.532 12.287 42 14.543 42 16.972c0 3.124-.59 5.797-1.767 8.018a23.822 23.822 0 01-4.367 5.883A43.733 43.733 0 0130.2 35.56a53.338 53.338 0 00-5.717 4.581 23.718 23.718 0 00-4.419 5.467c-1.178 2.013-1.767 4.477-1.767 7.393h-3.43c-.971-3.193-1.335-5.953-1.092-8.278.242-2.325.814-4.425 1.715-6.3a23.09 23.09 0 013.327-5.102 97.373 97.373 0 003.794-4.685 29.56 29.56 0 003.12-5.103c.866-1.804 1.299-3.887 1.299-6.247 0-1.32-.156-2.62-.468-3.905-.312-1.284-.832-2.412-1.56-3.384-.727-.972-1.663-1.753-2.806-2.343-1.144-.59-2.547-.885-4.21-.885-1.456 0-2.738.139-3.847.417-1.11.277-1.941.624-2.495 1.04L8.213 21.972zM8 66.554c0-2.566.857-4.633 2.57-6.2C12.285 58.783 14.558 58 17.389 58c2.832 0 5.141.784 6.93 2.352C26.106 61.92 27 63.987 27 66.553c0 2.567-.894 4.616-2.682 6.148C22.529 74.234 20.22 75 17.388 75c-2.831 0-5.104-.766-6.817-2.299C8.857 71.17 8 69.12 8 66.553z",
  id: "img-intro--kontakt_svg__?",
  stroke: "#151616",
  strokeWidth: 1.638,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

function SvgImgIntroKontakt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    "aria-labelledby": "support-intro-title support-intro-desc"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "static/img-intro--kontakt.9a2bbe51.svg";
export { SvgImgIntroKontakt as ReactComponent };